$(function () {
    // hide/show proper dropdown on page load (handles back button event)
    $('.js-itinerary-type-radio').each(function () {
        var $this = $(this);
        var id = $this.attr('data-id');
        var activityRadio = $('#activity-' + id);
        var locationRadio = $('#location-' + id);

        if (activityRadio && activityRadio.length > 0 && activityRadio[0].checked) {
            $("#locationList-" + id).parent('.js-itinerary-search__item').hide();
            $("#activityList-" + id).parent('.js-itinerary-search__item').show();
        } else if (locationRadio && locationRadio.length > 0 && locationRadio[0].checked) {
            $("#locationList-" + id).parent('.js-itinerary-search__item').show();
            $("#activityList-" + id).parent('.js-itinerary-search__item').hide();
        }
    });
});
window.onload = function () {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.activities != null) {
        $('input[value=activity]').prop("checked", true);
        $('input[value=location]').prop("checked", false);
        var selectedValue = params.activities.replace(/%20/g, " ");
        selectedValue = selectedValue.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
        selectedValue = selectedValue.replace(/(?:^|[\s-/])\w/g, function (a) { return a.toUpperCase(); });
        if (selectedValue.includes("And")) {
            selectedValue = selectedValue.replace("And", "and");
        }
        if (selectedValue.includes("Non-Ski")) {
            selectedValue = selectedValue.replace("Non-Ski", "Non-ski");
        }
        $('.activities-list').val(selectedValue);
        $(".locations-list").parent('.js-itinerary-search__item').hide();
        $(".activities-list").parent('.js-itinerary-search__item').show();
    }
    else if (params.locations != null) {
        $('input[value=activity]').prop("checked", false);
        $('input[value=location]').prop("checked", true);
        var selectedValue = params.locations.replace(/%20/g, " ");
        selectedValue = selectedValue.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
        selectedValue = selectedValue.replace(/(^|[\s-])\S/g, function (a) { return a.toUpperCase(); });
        $('.locations-list').val(selectedValue);
        $(".locations-list").parent('.js-itinerary-search__item').show();
        $(".activities-list").parent('.js-itinerary-search__item').hide();
    }

}

if (document.readyState === "loading") {
    // Calls the function during the 'DOMContentLoaded' event, after the HTML document has been completely loaded
    document.addEventListener("DOMContentLoaded", function () {
        LoadItinerarySearch();
    });
} else {
    // Calls the function directly in cases where the widget is rendered dynamically after 'DOMContentLoaded' has occurred
    LoadItinerarySearch();
}

function LoadItinerarySearch() {
    // hide/show proper dropdown when radio button changes
    $('.js-itinerary-type-radio').change(function () {
        var $this = $(this);
        var id = $this.attr('data-id');
        var activityRadio = $('#activity-' + id);
        var locationRadio = $('#location-' + id);

        if (activityRadio && activityRadio.length > 0 && activityRadio[0].checked) {
            $("#locationList-" + id).parent('.js-itinerary-search__item').hide();
            $("#activityList-" + id).parent('.js-itinerary-search__item').show();
        } else if (locationRadio && locationRadio.length > 0 && locationRadio[0].checked) {
            $("#locationList-" + id).parent('.js-itinerary-search__item').show();
            $("#activityList-" + id).parent('.js-itinerary-search__item').hide();
        }
    });
    // handle redirect when submit button is clicked
    $('.js-itinerary-search-submit').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var id = $this.attr('data-id');
        var baseUrl = $this.attr('data-href');
        var activityRadio = $('#activity-' + id);
        var locationRadio = $('#location-' + id);

        if (activityRadio && activityRadio.length > 0 && activityRadio[0].checked) {
            var activitySelect = $('#activityList-' + id);
            var activitySelectValue = activitySelect.find(':selected').val();
            if (activitySelectValue.length > 0) {
                window.location.href = baseUrl + "?activities=" + activitySelectValue;
            }
        } else if (locationRadio && locationRadio.length > 0 && locationRadio[0].checked) {
            var locationSelect = $('#locationList-' + id);
            var locationSelectValue = locationSelect.find(':selected').val();
            if (locationSelectValue.length > 0) {
                window.location.href = baseUrl + "?locations=" + locationSelectValue;
            }
        }
    });
}